import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
import { AuthorisedRoute } from "../authorised-route";
export var RequireAuth = function () {
    return (_jsx(AuthorisedRoute, { children: _jsx(Outlet, {}, void 0) }, void 0));
};
